import { OnInit, ElementRef, OnDestroy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatTableDataSource, MatSort, Sort } from '@angular/material';
import { DEFAULT_FORMATS, dateFormat } from 'src/app/share/utils/common-utils';
import { EsWarehouseService } from 'src/app/restapi/be-esquery';
import { take, tap, takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as XLSX from 'xlsx';
import * as _moment from 'moment';
var moment = _moment;
var ɵ0 = DEFAULT_FORMATS;
var WarehouseEventShippingComponent = /** @class */ (function () {
    function WarehouseEventShippingComponent(fb, esWarehouseService) {
        this.fb = fb;
        this.esWarehouseService = esWarehouseService;
        this.dataList = [];
        this.dataSource = new MatTableDataSource([]);
        this.displayedColumns = ['search_yyyy_mm', 'recycle_place_name', 'event_name', 'give_good_detail_cate_1', 'give_good_detail_cate_2', 'give_good_detail_cate_3', 'give_good_detail_cate_4', 'give_good_detail_cate_5', 'give_good_detail_cate_6',
            'give_good_detail_cate_7', 'give_good_detail_cate_8', 'give_good_detail_cate_9', 'give_good_detail_cate_10', 'give_good_detail_cate_11', 'give_good_detail_cate_12'];
        this.minDate = moment().add(-3, 'month');
        this.maxDate = moment();
    }
    WarehouseEventShippingComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.initForm();
        this.sort.sortChange.pipe(tap(function (sort) {
            _this.initPage(sort);
        }), takeUntil(componentDestroyed(this))).subscribe();
    };
    WarehouseEventShippingComponent.prototype.ngOnDestroy = function () { };
    WarehouseEventShippingComponent.prototype.initForm = function () {
        this.form = this.fb.group({
            gte_date: this.minDate,
            lte_date: this.maxDate,
            dept_info: null
        });
    };
    Object.defineProperty(WarehouseEventShippingComponent.prototype, "fc_gteDate", {
        get: function () { return this.form.get('gte_date'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WarehouseEventShippingComponent.prototype, "fc_lteDate", {
        get: function () { return this.form.get('lte_date'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WarehouseEventShippingComponent.prototype, "fc_deptInfo", {
        get: function () { return this.form.get('dept_info'); },
        enumerable: true,
        configurable: true
    });
    WarehouseEventShippingComponent.prototype.onChangeStartDate = function () {
        var limitDate = moment(this.fc_gteDate.value).add(3, 'month');
        this.minDate = this.fc_gteDate.value;
        if (this.fc_gteDate.value > this.fc_lteDate.value) {
            this.fc_lteDate.setValue(this.fc_gteDate.value);
        }
        if (limitDate < this.fc_lteDate.value) {
            this.fc_lteDate.setValue(limitDate);
        }
    };
    WarehouseEventShippingComponent.prototype.onChangeEndDate = function () {
        var limitDate = moment(this.fc_lteDate.value).add(-3, 'month');
        if (limitDate > this.fc_gteDate.value) {
            this.fc_gteDate.setValue(limitDate);
            this.minDate = limitDate;
        }
    };
    WarehouseEventShippingComponent.prototype.selectDept = function (value) {
        if (!value || value == null) {
            this.fc_deptInfo.setValue(null);
            return;
        }
        this.fc_deptInfo.setValue(value);
        this.search();
    };
    WarehouseEventShippingComponent.prototype.initPage = function (sort) {
        if (!this.dataList)
            this.dataList = [];
        var sorted = this.dataList;
        if (sort) {
            sorted = this.dataList.sort(function (a, b) {
                var result = 0;
                if (a[sort.active] == undefined)
                    a[sort.active] = "";
                if (b[sort.active] == undefined)
                    b[sort.active] = "";
                if (a[sort.active] < b[sort.active])
                    result = -1;
                else if (a[sort.active] > b[sort.active])
                    result = 1;
                return result * (sort.direction === 'asc' ? 1 : -1);
            });
        }
        this.dataList = sorted;
        this.dataSource = new MatTableDataSource(this.dataList);
    };
    WarehouseEventShippingComponent.prototype.search = function () {
        this.eventShippingGet();
    };
    WarehouseEventShippingComponent.prototype.exportTOExcel = function () {
        var ws = XLSX.utils.table_to_sheet(this.table.nativeElement);
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, '행사출고통계');
        XLSX.writeFile(wb, '행사출고통계.xlsx');
    };
    WarehouseEventShippingComponent.prototype.eventShippingGet = function () {
        var _this = this;
        this.dataList = [];
        this.esWarehouseService.warehouseRecyclePlaceEventShippingStatisticalTableGet(dateFormat(this.fc_gteDate.value), dateFormat(this.fc_lteDate.value), this.fc_deptInfo.value != null ? this.fc_deptInfo.value.dept_id : null).pipe(take(1)).subscribe(function (res) {
            _this.dataList = res;
            _this.initPage(_this.sort);
        }, function (err) {
            console.error(err);
            _this.initPage(_this.sort);
        });
    };
    return WarehouseEventShippingComponent;
}());
export { WarehouseEventShippingComponent };
export { ɵ0 };
